import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ForgotPasswordService {

  constructor(private http: HttpClient) { }

  changePassword(glid: string, confirmPassword: string): Observable<any> {
    return this.http.get<any>(environment.url + '/ForgotPassword?userId=' + glid +
                                                 '&password=' + confirmPassword +
                                                 '&clientCode=' + environment.clientShortCode);
  }
}
